import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  stroke: "white"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "0.75",
      y: "0.75",
      width: "12.5",
      height: "12.5",
      rx: "0.5",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-dasharray": "2.68 2.68",
      fill: "none"
    }, null, -1)
  ]))]))
}
export default { render: render }